import './apcp.scss';

import * as React from 'react';
import { Context } from '../../../context/dataStore';

import RenderButton from './RenderButton/RenderButton';
import './RenderButton/RenderButton.scss';

import { triggerModal} from '../../../utils/utils';

import { getModuleStatusStr, alertShow } from '../../../utils/utils';
import Util from '../../../utils/APCPUtil';
import SuccessMessageModal from '../ModulePage/Modals/SuccessMessageModal';
import ErrorMessageModal from '../ModulePage/Modals/ErrorMessageModal';
import SubmitModalConfirmation from '../../../components/Modals/submitConfirmation';
import UnsubmitConfirmation from '../../../components/Modals/unsubmitConfirmation';
import PublishModalConfirmation from '../../../components/Modals/publishConfirmation';
import PublishModal from '../../../components/Modals/publishModal';
import BasicErrorModal from '../../../components/Modals/errorModal';
import SubmitModal from '../../../components/Modals/submitModal';
import ForgotToSaveModal from '../../../components/Modals/forgotToSaveModal';
//import ModalComponent from '../../../components/Modals';
import { saveSuccessMsg, saveErrorMsg, lockMsg, lockMsgAdmin, submitSuccessMsg, unsubmitSuccessMsg, publishSuccessMsg } from '../../../constants/messages';
import { SUBMITTED_FOR_REVIEW, PUBLISHED} from '../../../constants/status';
import { ADMIN_ROLE } from '../../../constants/global';
import ApExam from './ApExam/ApExam';
import { ToolTip } from '../../../components';
import { triggerToaster } from '../../../utils/utils';



const APCP = ({ CategoryName, org_id, cat_id, status, org_rol_s, categTooltip, categoryData, setCategoryStatus,
  catDispatcher, setPageDirty}) => {
  // getting data from context
  const { submitModule, unsubmitModule, getAPCP, postAPCPModule, publishCategory } = React.useContext(Context);

  //modifiedOn
  const [modifiedOn, setModifiedOn] = React.useState('Unmodified');


  //Same logic can be found in ModuleDetail.js to determine it it's read only
  const [readOnly, setReadOnly] = React.useState(false);

  //for submission errors
  const [tableData, setTableData] = React.useState([]);
  //reuse messages
  const [alertMessage, setAlertMessage] = React.useState({ id: -1, message: '' });
  //for save
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const [moduleData, setModuleData] = React.useState([]);
  const [answers, setAnswers] = React.useState({});
  const [moduleErrors, setModuleErrors] = React.useState([]);
  const [appliedModuleIds, setAppliedModuleIds] = React.useState([]);
  const [moduleIdMap, setModuleIdMap] = React.useState();
  const [defaultQuestions, setDefaultQuestions] = React.useState({});
  const [unsavedNames, setUnsavedNames] = React.useState([]);
  const [displayMsg, setDisplayMsg] = React.useState();
  const [publishError, setPublishError] = React.useState();
  const [enableEdit, setEnableEdit] = React.useState(true);
  const [enableNewPolicy, setEnableNewPolicy] = React.useState(true);
  const [enableRenderBtn, setEnableRenderBtn] = React.useState(true);
  const [isCatLocked, setIsCatLocked] = React.useState(false);


  React.useEffect(() => {
    let isCurrent = true;
    const fetchData = async () => {
      const res = await getAPCP(parseInt(org_id));
      const rowDataArr = [];
      const metaData = Util.matchQuestionsToAnswers(rowDataArr, res.data.data[0]);

      const idmap = Util.findAllModulesIdMap(res.data.data[0]);
      setModuleIdMap(() => idmap);

      if (metaData.modules.length > 0) {
        let metaArray = [];
        rowDataArr?.map(m => {
          const moduleTb = {};
          moduleTb.rowData = m;
          moduleTb.data = metaData?.modules?.find(sd => sd.module === m.moduleId);
          if (moduleTb.data) {
            moduleTb.data.cid = metaData.cid;
            moduleTb.data.id = metaData.id;
          }
          metaArray.push(moduleTb);
        });
        //map res to moduleData
        setModuleData(() => Util.sortAPCP(metaArray));
        setModifiedOn(getModuleStatusStr('Modified', `${res.data.data[0].last_updated_at}`));
      }

      const cid = res.data.data[0].id;
      const id = res.data.data[0].modules[0].question_groups[0].id;
      const questions = [...res.data.data[0].modules[0].question_groups[0].questions];
      questions.map(e=>{e.id=e.api_attribute;});
      const dq = {cid:cid, id:id, questions:[...questions]};
      setDefaultQuestions(()=>dq);

      const c = categoryData?.filter(e=>e.api_attribute==='apcpCreditPolicyCategory');
      let lockstatus = c[0]?.is_locked === true;
      setIsCatLocked(lockstatus);
      
      if(org_rol_s===ADMIN_ROLE){
        if(status?.toUpperCase() === PUBLISHED){
          setReadOnly(true);
        }
      }
      else{
        if(lockstatus===true){
          setReadOnly(true);
        }
        else if(status?.toUpperCase() === SUBMITTED_FOR_REVIEW || status.toUpperCase() === PUBLISHED){
          setReadOnly(true);
        }
      }
    };
    if (isCurrent) {
      fetchData();
    }
    return () => isCurrent = false;
  }, []);

  React.useLayoutEffect(() => {
    let isCurrent = true;
    if (isCurrent) {
      window.scrollTo(0, 0);
    }
    return () => isCurrent = false;
  }, []);

  React.useEffect(() => {
    const names = Util.findModuleNameById(appliedModuleIds, moduleIdMap);
    setUnsavedNames(names);
  }, [appliedModuleIds, moduleIdMap]);

  const setCatStatus = (catStatus)=>{
    const newcategoryData = categoryData;
    newcategoryData.forEach(el => {
      if (el.id === cat_id) {
        el.status = catStatus;
      }
    });

    setCategoryStatus(catStatus);
    catDispatcher({ type: "GET_CATEGORY_DATA", payload: newcategoryData });
  };

  //submit
  const submitAction = async () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const putdata = [{
      id: parseInt(cat_id),
      status: SUBMITTED_FOR_REVIEW
    }];
    try {
      const res = await submitModule(putdata, org_id);
      if (res.data.status === 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        setTableData(res?.data.data);
        triggerModal('submitfailedtrigger');
      } else {
        //submitted
        setCatStatus(res.data.data[0].status);
        if(org_rol_s !== ADMIN_ROLE){
          setReadOnly(true);
        }
        triggerToaster(submitSuccessMsg);
      }
    } catch (error) {
      setAlertMessage({id: 'errorMessageModal', message: 'server error'});
      triggerModal('errorMessageModal');
    }
  };

  const onSubmit = async () => {
    //if page is dirty
    if (appliedModuleIds.length > 0) { 
      triggerModal('forgottosavemodal');
    } else {
      triggerModal('confirmsubmitconfirmation');
    }
  };

  // Runs the unsubmit API then verifies
  const unsubmitAction = async() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    try {
      const res = await unsubmitModule(org_id, cat_id);
      if (res.data.status === 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        triggerModal('unsubmiterror');
      } else {
        setCatStatus(res.data.data.status);
        setReadOnly(false);
        triggerToaster(unsubmitSuccessMsg);
      }
    } catch (error) {
      setAlertMessage({id: 'errorMessageModal', message: 'server error'});
      triggerModal('errorMessageModal');
    } 
  };
  //Activates Confirmation page
  const unSubmit = async () => {
    if (appliedModuleIds.length > 0) { 
      triggerModal('forgottosavemodalunsubmitversion');
    } else {
      triggerModal('confirmunsubmitconfirmation');
    }
  };

  const onSave = async () => {
    let overAllanswers = [];
    for (const mid of appliedModuleIds) {
      let answers = { module_id: parseInt(mid), current_value: [] };
      for (const md of moduleData) {
        const mddata = md.data;
        if (mddata.module.includes(`${mid}-`)) {
          answers.current_value.push(mddata.currentValue);
        }
      }
      answers.category_id = parseInt(defaultQuestions.cid);
      answers.question_group_id = parseInt(defaultQuestions.id);
      overAllanswers.push(answers);
    }

    if (overAllanswers.length > 0) {
      //call api, get last updated time.
      const result = await postAPCPModule(overAllanswers, org_id);
      const { status, data } = result;

      if (status !== 200) { //could be system error
        setAlertMessage({ id: 'errorMessageModal', message: 'system error' });
        alertShow('error', 'errorMessageModal');
      } else {
        if (data.status !== 'SUCCESS') {
          setAlertMessage({ id: 'errorMessageModal', message: saveErrorMsg });
          alertShow('error', 'errorMessageModal');
        } else {
          if (data.data[0]) { //real saved
            setModifiedOn(getModuleStatusStr('Modified', `${data.data[0].last_updated_at}`));
            setCatStatus(data.data[0].category_status);
            setPageDirty('N');
            triggerToaster(saveSuccessMsg);
            setAppliedModuleIds(() => []);
          }
        }
      }
    }
  };

  const onPublish = async ()=>{
    window.scrollTo({ top: 0, behavior: 'smooth' });
    triggerModal("publishconfirmationAPCP");
  };

  const publish = async()=>{
    try{
      const putdata = [{
        "id":cat_id,
        "status": "PUBLISHED"
      }];

      const res = await publishCategory(putdata, org_id);
      //if error
      if (res.data.status === "Error" || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        setPublishError(res?.data.data);
        triggerModal("publisherror");
      } 
      else {
        //published
        setEnableNewPolicy(false);
        setReadOnly(true);
        triggerToaster(publishSuccessMsg);
        setCatStatus(res.data.data[0].status);
      }
    }catch (err) {
     catDispatcher({type: "ERROR", payload: err});
    }
  };


  return (
    <div className='container-apcp' id='wholeDiv' role='region' aria-label='apcp'>
      <SubmitModal modalId='submitfailedtrigger' modalData={tableData} />
      <SubmitModalConfirmation submitAction={() => submitAction()} modalId='confirmsubmitconfirmation' />
      <UnsubmitConfirmation unsubmitAction={()=> unsubmitAction()} modalId='confirmunsubmitconfirmation' />
      <BasicErrorModal modalId='unsubmiterror' unsubmitAction={unSubmit}/>
      <ForgotToSaveModal submitAction={() => submitAction()} modalId='forgottosavemodal' bodycontent={[]} />
      <ForgotToSaveModal submitAction={() => unsubmitAction()} modalId='forgottosavemodalunsubmitversion' bodycontent={[]} title={"Your unsaved changes will not be saved."} label={"Unsubmit"} />
      <ErrorMessageModal message={alertMessage.message} />
      <SuccessMessageModal message={displayMsg} />
      <PublishModalConfirmation publishAction={()=>publish()} modalId='publishconfirmationAPCP' />
      <PublishModal modalData={publishError} modalId='publisherror'/>

      <div className='apcpcontainer'>
        <div className='row' style={{width:'94%'}}>
          <span role='heading' aria-level='2' id='apcpexamtitle' style={{width:'50%'}}>AP Exam Credit Policy&nbsp;&nbsp;
          {isCatLocked?
            <ToolTip tooltipid={'tip_APCP_'+cat_id} 
            tooltipMsg={org_rol_s===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
            innerMsg={''} className={'cb-icon cb-lock'} />:<></>}</span>
          <span id='lastmodified' style={{width:'50%', textAlign:'right'}}>{modifiedOn} </span>
        </div>

        <div className='row'>
          <span style={{width:'94%'}}>
            The following table lists the information that we currently have about your institution’s AP credit policies. Select 'Add New Policy' to add a new
            exam policy. Select 'Edit' to verify and update any prepopulated information. Make sure to click 'Save' at the top of the page to retain
            your changes before selecting 'Submit for Review'.
          </span>
        </div>

        {/* TABLE FOR Policy */}
        <div className='row'>
          <ApExam moduleData={moduleData}
            setModuleData={setModuleData}
            answers={answers}
            setAnswers={setAnswers}
            appliedModuleIds={appliedModuleIds}
            setAppliedModuleIds={setAppliedModuleIds}
            moduleErrors={moduleErrors}
            setModuleErrors={setModuleErrors}
            moduleIdMap={moduleIdMap}
            defaultQuestions={defaultQuestions}
            setPageDirty={setPageDirty}
            readOnly={readOnly}
            enableEdit={enableEdit}
            setEnableEdit={setEnableEdit}
            enableNewPolicy={enableNewPolicy}
            setEnableNewPolicy={setEnableNewPolicy}
            enableRenderBtn={enableRenderBtn}
            setEnableRenderBtn={setEnableRenderBtn}

          />
        </div>
      </div>

      <div className='container-navigation cb-sticky cb-sticky-active cb-sticky-bottom' style={{"backgroundColor":"#324dc7",'height':'80px'}}>
        <RenderButton isSaving={isSaving} isSubmitting={isSubmitting} saveAction={onSave}
         submitAction={onSubmit} unsubmitAction={unSubmit} org_rol_s={org_rol_s} 
         status={status} enable={enableRenderBtn} readOnly={readOnly}
         onPublish={onPublish}
         />
      </div>
    </div>
  );
};

export default APCP;
